import { FC } from 'react'
import { DialogActions, Button, Box } from '@mui/material'
import { StatefulDialog } from 'src/components/ui'
import { DialogNames } from 'src/enums'

interface Props {
  dialogName: DialogNames
  onSubmit: () => void
  onCancel: () => void
  isLoading?: boolean
  actionButtonName: string
  content: React.ReactNode
}

export const SensorModal: FC<Props> = ({ dialogName, onSubmit, onCancel, isLoading = false, actionButtonName, content }) => {
  return (
    <StatefulDialog
      name={dialogName}
      actions={
        <Box mb={2} mx={2}>
          <DialogActions>
            <Button variant="outlined" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="contained" color="error" onClick={onSubmit} disabled={isLoading}>
              {actionButtonName}
            </Button>
          </DialogActions>
        </Box>
      }
    >
      <Box minWidth="300px">{content}</Box>
    </StatefulDialog>
  )
}
